import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Approach_1_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/approach/2`, {
      replace: true,
    });
  };

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 255px)",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            다양한 시도를 해오셨을 겁니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            다른 대안도 많습니다. 사람마다 적합한 방식이 다를 수 있습니다.
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            내게는 어떤 치료적 접근이 가장 적절한지 알아보도록 하겠습니다.
          </CustomTypography>
        </Stack>
      </Box>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
      />
    </Box>
  );
}
